import React from 'react';

export function TaskCardDescription({ children }: { children: React.ReactNode }) {
    return <> {children} </>;
}
